// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G0Pf","left":"styles_left__WyqDZ"};